import React, { FunctionComponent, ReactNode, useCallback, useMemo, useState } from "react";
import { connect } from "react-redux";

import ConnectedTradeFilterPanel from "../../filter_bar/trade_filter_panel";
import getProjectId from "../../../services/getters/project_getters/get_project_id";
import TradeFilterDropdown from "../../filter_bar/trade_filter_dropdown";
import useProject from "../../../queries/projects/use_project";
import useTrades from "../../../queries/trades/use_trades";
import { useFlags } from "../../../services/utilities/launch_darkly_helper";

export type OwnProps = { icon?: ReactNode };

export type Props = OwnProps & ReturnType<typeof mapStateToProps>;

// Separate from NavBarSecondary so these queries only run on the Viewer — NavBarSecondary itself
// mounts on every page. Variant choice mirrors filter_bar.tsx so behaviour is unchanged.
export const NavBarSecondaryTrades: FunctionComponent<Props> = ({ projectId, icon }) => {
  const { explorerTradeFilterPanel } = useFlags();
  // isInitialLoading is the field client_user_router reads for this same check.
  const { data: project, isInitialLoading: isProjectLoading } = useProject(projectId);
  const { data: trades } = useTrades(projectId);
  const [open, setOpen] = useState(false);

  const openFlyout = useCallback(() => setOpen(true), []);
  const closeFlyout = useCallback(() => setOpen(false), []);

  // Same rule as client_user_router's tradesEnabled.
  const tradesTsvFilter = useMemo(() => {
    if (!isProjectLoading && project?.settings?.tradeFilterForceUniformat) {
      return false;
    }
    return Object.keys(trades ?? {}).length > 0;
  }, [isProjectLoading, project, trades]);

  if (explorerTradeFilterPanel) {
    return <ConnectedTradeFilterPanel tradesTsvFilter={tradesTsvFilter} icon={icon}/>;
  }

  return <TradeFilterDropdown
    open={open}
    tradesTsvFilter={tradesTsvFilter}
    openFlyout={openFlyout}
    closeFlyout={closeFlyout}
    openNext={closeFlyout}
    openPrevious={closeFlyout}
    icon={icon}
  />;
};

const mapStateToProps = (state, props) => ({
  projectId: getProjectId(state, props),
});

export default connect(mapStateToProps)(NavBarSecondaryTrades);
